<template>
  <div>
    <am-list-page
      title="Departments"
      :columns="columns"
      :rows="departments"
      :table-loading="loading"
      :show-create="false"
      :show-search="true"
    >
      <template slot="right-extra-header-actions">
        <am-button
          icon="PlusIcon"
          label="Add Department"
          @click="openSetup()"
        />
      </template>
      <template #actions="{row}">
        <am-button
          icon-only
          icon="Edit2Icon"
          variant="flat-primary"
          @click="openSetup(row.item)"
        />
        <am-button
          icon-only
          icon="TrashIcon"
          variant="flat-danger"
          @click="remove(row.item)"
        />
      </template>
    </am-list-page>

    <am-modal
      :show="opened"
      :title="editing && editing.id ? 'Edit Department' : 'Add Department'"
      :loading="saving"
      ok-text="Save"
      @onClose="opened = false"
      @onOk="save"
    >
      <am-input
        v-model="form.name"
        name="name"
        label="Department name"
        rules="required"
      />
      <template slot="modal-actions">
        <b-row class="float-right">
          <am-button
            name="cancel"
            variant="flat-danger"
            icon="XIcon"
            class="mr-1"
            label="Cancel"
            @click="opened = false"
          />
          <am-button
            name="save_department"
            label="Save"
            :loading="saving"
            loading-text="Loading..."
            @click="save"
          />
        </b-row>
      </template>
    </am-modal>
  </div>
</template>

<script>
import AmListPage from '@/farmbusiness/components/AmListPage.vue'
import AmButton from '@/farmbusiness/components/AmButton.vue'
import AmModal from '@/farmbusiness/components/AmModal.vue'
import AmInput from '@/farmbusiness/components/AmInput.vue'
import { BRow } from 'bootstrap-vue'
import showToast from '@/farmbusiness/mixins/showToast'
import confirm from '@/farmbusiness/mixins/confirm'

export default {
  name: 'DepartmentsIndex',
  components: {
    AmListPage, AmButton, AmModal, AmInput, BRow,
  },
  mixins: [showToast, confirm],
  data() {
    return {
      loading: false,
      opened: false,
      saving: false,
      editing: null,
      form: { name: null },
      columns: [
        { key: 'name', label: 'Name' },
        { key: 'actions', label: '' },
      ],
    }
  },
  computed: {
    departments() {
      return this.$store.getters['employeeCentre/departments']
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      this.$store.dispatch('employeeCentre/fetchDepartments')
        .finally(() => { this.loading = false })
    },
    openSetup(row = null) {
      this.editing = row
      this.form = { name: row?.name || null }
      this.opened = true
    },
    save() {
      this.saving = true
      const action = this.editing?.id
        ? this.$store.dispatch('employeeCentre/updateDepartment', { id: this.editing.id, data: this.form })
        : this.$store.dispatch('employeeCentre/createDepartment', this.form)
      action.then(() => {
        this.showSuccess('Department saved')
        this.opened = false
        this.load()
      }).catch(() => this.showError('Failed to save department'))
        .finally(() => { this.saving = false })
    },
    remove(row) {
      this.confirmAction('Delete this department?').then(ok => {
        if (!ok) return
        this.$store.dispatch('employeeCentre/deleteDepartment', row.id)
          .then(() => this.showSuccess('Department deleted'))
          .catch(() => this.showError('Failed to delete department'))
      })
    },
  },
}
</script>
